




















import './KisweDateSelector.scss'
import { DatePicker } from 'element-ui'
import { generateRandomString } from '@/modules/common/utils'
import { computed, defineComponent } from '@vue/composition-api'
import { DatePickerOptions } from 'element-ui/types/date-picker'
import { Validation } from '@vuelidate/core'
import ValidationErrors from '../ValidationErrors'

export default defineComponent({
  name: 'KisweDateSelector',
  components: {
    'el-date-picker': DatePicker,
    ValidationErrors
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'datetime'
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    format: {
      type: String,
      required: false,
      default: 'MM/dd/yyyy HH:mm:ss'
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: Date,
      required: false,
      default: new Date()
    },
    placeholder: {
      type: String as () => string|null,
      required: false,
      default: 'Select date and time'
    },
    options: {
      type: Object as () => DatePickerOptions,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    visible: {
      type: Boolean,
      required: false,
      default: true
    },
    size: {
      type: String,
      required: false,
      default: 'default'
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    },
    tooltip: {
      type: String,
      required: false,
      default: ''
    },
    validator: {
      type: Object as () => Validation,
      required: false
    }
  },
  setup (props, { emit }) {
    const date = computed({
      get: () => props.value,
      set: (newVal: Date) => {
        emit('input', newVal)
      }
    })
    return {
      date,
      pickerOptions: computed(() => ({ firstDayOfWeek: 1, ...props.options })),
      id: `kiswe-date-selector--${ generateRandomString(12, false) }`
    }
  }
})
